import React, { useState } from 'react';
import classnames from 'classnames';
import styles from './section.module.scss';
import { ChevronUp } from 'react-feather';

interface SectionProps {
  title: string;
  position?: 'left' | 'center';
  className?: string;
  children?: React.ReactNode;
  customRight?: React.ReactNode;
}

export const CollapseSection: React.FC<SectionProps> = ({
  title,
  position,
  customRight,
  className,
  children,
}) => {
  const [isOpen, setIsOpen] = useState(true);

  const toggleCollapse = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <section className={styles.collapse_section}>
      <div className='mt-10 flex items-center justify-between bg-white py-4 pr-[30px]'>
        <div className='flex items-center gap-2'>
          <h2 className={styles['collapse_section--title']}>{title}</h2>
          {customRight}
        </div>
        <ChevronUp
          width={24}
          height={24}
          onClick={toggleCollapse}
          className={classnames('cursor-pointer', {
            'rotate-180 transition-transform duration-300': !isOpen,
          })}
        />
      </div>
      <div
        className={classnames(styles['collapse_section--content'], className, {
          'h-0 !max-h-0': !isOpen,
        })}
      >
        <div
          className={
            styles[
              `collapse_section--container-${position ? position : 'left'}`
            ]
          }
        >
          {children}
        </div>
      </div>
    </section>
  );
};
